import React from 'react';
import { useUnreadMessagesCount } from '@cp/entities/dialog';
import { useClientWebRouteParams, usePathGenerator } from '@cp/entities/clientWebRoutes';
import { coreCurrentClientApi } from '@cp/entities/client';
import { useIsLoggedIn } from '@cp/entities/currentUser';
import { useGetQueryParams } from '@cp/shared/queryParams';
import { ClientType } from '@common/model/client/clientType';
import { useNavigateToCatalog } from 'src/features/catalog';
import { useClientLogin } from 'src/features/client/current/login';
import { useRegistrationForSpecialist } from 'src/features/client/current/registration/specialist';
// FIXME wrong entirypoint
import { useEmployerPreFilterRegistration } from 'src/features/registration/model/preFilter';
import { useBurgerMenuController } from 'src/features/burgerMenu';
import { useWithTrack } from 'src/shared/tracking';
import { findHelperEvent, findJobEvent, messagesTabEvent } from '../lib';
import { ItemsCreatorProps, UseItemsProps, UseItemsReturn } from './types';
import { createClientItems } from './createClientItems';
import { createGuestItems } from './createGuestItems';

export const useItems = (props: UseItemsProps): UseItemsReturn => {
  const withTrack = useWithTrack();
  const generateAppPath = usePathGenerator();
  const isLoggedIn = useIsLoggedIn();
  const { data: clientProfile } = coreCurrentClientApi.useGetProfileQuery(undefined, {
    skip: !isLoggedIn,
  });
  const routeParams = useClientWebRouteParams();
  const unreadMessagesCount = useUnreadMessagesCount();
  const { isLoading: isLoadingNavigate, navigateToCatalog } = useNavigateToCatalog();
  const onLogin = useClientLogin();
  const onSpecialistRegistration = useRegistrationForSpecialist();
  const onEmployerPreFilterRegistration = useEmployerPreFilterRegistration();
  const queryParams = useGetQueryParams();
  const burgerMenuController = useBurgerMenuController();

  return React.useMemo(() => {
    const creatorProps: ItemsCreatorProps = {
      ...props,
      generateAppPath,
      routeParams,
      unreadMessagesCount,
      isLoadingNavigate,
      navigateToCatalog: withTrack(
        () => {
          return clientProfile?.type === ClientType.Employer ? findHelperEvent() : findJobEvent();
        },
        () => navigateToCatalog(),
      ),
      // eslint-disable-next-line @typescript-eslint/no-empty-function,no-empty-function
      onMessagesTabClick: withTrack(messagesTabEvent, () => {}),
      burgerMenuController,
      onLogin,
      onSpecialistRegistration,
      onEmployerPreFilterRegistration,
      queryParams,
    };

    if (clientProfile) {
      return createClientItems({
        ...creatorProps,
        clientProfile,
      });
    } else {
      return createGuestItems(creatorProps);
    }
  }, [
    burgerMenuController,
    clientProfile,
    generateAppPath,
    isLoadingNavigate,
    navigateToCatalog,
    onEmployerPreFilterRegistration,
    onLogin,
    onSpecialistRegistration,
    props,
    queryParams,
    routeParams,
    unreadMessagesCount,
    withTrack,
  ]);
};
